function FeatureBox({ children }) {
    return (
        <div className="bg-olm-gradient-t-to-b p-px rounded-md shadow-[0_4px_20px_rgba(242,130,48,0.2)]">
            <div className="h-full grid place-items-center bg-white py-6 px-6 space-y-4 rounded-md">
                {children}
            </div>
        </div>
    )
}

export default FeatureBox
